import React from 'react';
import styled from 'styled-components';
import data from '../Assets/data.json';
import 'bootstrap/dist/css/bootstrap.min.css';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #83FCD0;
  
  @media(min-width: 769px) {
  justify-content: flex-start;
  padding: 2rem 21%;
  }
  
  @media(max-width: 768px) {
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 2rem 10%;
  }
  
  @media(max-height: 900px ) and (min-width: 1024px) {
    padding: 2rem 15%;
  }
`;

const Container = styled.div`
  display: flex;
  align-items: center;
  
  @media(min-width: 769px) {
    flex-direction: row;
    justify-content: space-between;
  }
  
  @media(max-width: 768px) {
    flex-direction: column;
    justify-content: center;
  }
`;

const ContactWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding-top: 1rem;
`;

const Title = styled.h2`
  font-weight: bolder;
`;

const ContactSection = () => {
    return (
        <Wrapper id="contact-section">
            <Title>{data.contact.title}</Title>
            <Container>
                <ContactWrapper>
                    <p><strong>{data.contact.contact}</strong></p>
                    <span>{data.contact.phone}</span>
                    <span>{data.contact.email}</span>
                </ContactWrapper>
                <ContactWrapper>
                    <p><strong>{data.contact.address}</strong></p>
                    <span>{data.contact.street}</span>
                    <span>{data.contact.text1}</span>
                    <span>{data.contact.text2}</span>
                </ContactWrapper>
            </Container>
        </Wrapper>
    );
};

export default ContactSection;
